import React, { useCallback, useEffect, useState } from 'react'
import Loader from '../../elements/Loader';
import { toast } from 'react-toastify';
// import { Nav, Tab } from "react-bootstrap";
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import * as moment from 'moment';
import io from 'socket.io-client';
import './SfaChat.scss';
import { withTranslation } from "react-i18next";
import {connect } from "react-redux";
import secureStorage from '../../../config/encrypt';
import { API_URL } from '../../../config/constant';
import { InventoryService } from "../../../service";
import IfApplicationService from '../../../service/IfApplicationService';
import { ROLE_MAPPING_SHOW_TEXT } from '../../../config/config';
import LeadListFilter from './LeadListTopFilter';


const statusList=[
  {label: 'Incomplete' , value:1},
  {label: 'Submitted' , value:2},
  {label: 'Verified' , value:3},
  {label: 'Collateral Appraised' , value:4},
  {label: 'Credit Ops Approved' , value:5},
  {label: 'Resubmission' , value:6},
  {label: 'Rejected' , value:7},
  {label: 'Completed' , value:8}
];

const SfaChat = (props) => {
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [statusOption] = useState(statusList);
    const [pageCount, setPageCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [leadId] = useState(0);
    const [applicationId, setApplicationId] = useState(0);
    const [messages, setMessages] = useState('');
    const [messageBox, setMessageBOx] = useState("");
    const [chatdata, setChatdata] = useState([]);
    const [ticketData, setTicketData] = useState({});
    const [socket, setSocket] = useState(null);
    const [applicationDetails, setApplicationDetails]= useState([]);
    const logInUserInfo = secureStorage?.getItem("loginUserInfo")?.data?.user_data || {};
    const token=secureStorage.getItem("authToken");
    const headers={
      headers: { Authorization: token }
    };

    // eslint-disable-next-line no-unused-vars
    const [redirect, setRedirect] = useState("");
    
    // State to track connection status
    // eslint-disable-next-line no-unused-vars
    const [isConnected, setIsConnected] = useState(false);


    useEffect(() => {
      return () => {
        if (socket) {
          socket.disconnect();
          console.log('Socket disconnected on unmount');
        }
      };
    }, [socket]);
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(()=>{
        getChatList()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const updateReduxData = async () => {
      const loginResponse = secureStorage.getItem("loginUserInfo");
      if (!loginResponse) {
          setRedirect("/login");
          return;
      }
      props.updateStateIntoRedux("LOGIN_USER", loginResponse);
      const userRole = loginResponse?.data?.user_data?.role;
      if (userRole !== "admin") {
          setRedirect("/");
      }
  };
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
      updateReduxData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
    

    async function getChatList(page_num=1,filterData={}){
        setLoading(true);
        const response = await axios.post(`${API_URL.CHAT_URL}if-app/get-all-ticket`, {
            "user_id":logInUserInfo?.user_id,
            "page_num":page_num,
            "source":"web",
            "application_id": 0, 
            "name": logInUserInfo?.name,
            ...filterData,
        },headers);
        if(response?.data?.data?.length){
            setChatdata(response?.data?.data);
            setPageCount(response?.data?.pagination?.totalrecords)
        }else{
            setChatdata([]);
            setPageCount(0)
        }
        setLoading(false);
    }

    const handlePageClick = (selectedPage) => {
        setPageCount(selectedPage?.selected);
        getChatList(+selectedPage?.selected+1,{...filterData});
    };

    const connectSocket=async (application_id=0)=>{

        // Disconnect the existing socket if it exists
        if (socket) {
          socket.disconnect();
        }
        // Connect to the Socket.IO server
        const newSocket = io(`${API_URL.CHAT_URL_SOCKET}socket`); 
        // Change URL to your server's URL
        newSocket.on('connected', async () => {
          const response = await IfApplicationService.getApplicationDetails({ application_id });
          setApplicationDetails(response?.data?.data?.if_application_details)
          await getLeadDetails(application_id)
            setIsConnected(true);
            newSocket.emit('ifJoinRoom',{ application_id: application_id , user_id : logInUserInfo?.user_id,source:"web" });
            setApplicationId(application_id);
            newSocket.emit("ifGetChatMessages",{application_id: application_id,source: "web"})
            
            console.log('Connected to Socket.IO server!');
        });

        newSocket.on('ifLeftRoom', async () => {
            console.log('Successfully left in room');
        });

        newSocket.on('ifJoinedRoom', async () => {
          console.log('Successfully Joined in room');
        });

        newSocket.on('disconnected', () => {
            setIsConnected(false);
            newSocket.emit('ifLeaveRoom',{ application_id: application_id,user_id:logInUserInfo?.user_id })
            console.log('Disconnected from Socket.IO server');
        });
        newSocket.on("ifNewMessage",(data)=>{
          console.log("New Message")
            newSocket.emit("ifGetChatMessages",{application_id: application_id, page_num:1,source: "web"})
        });

        newSocket.on("ifChatList",(data)=>{
          console.log("Chat List")  
            // eslint-disable-next-line no-unused-vars        
            let msg=messages;
            console.log(data);
            setTicketData(data?.chatTicket)
            setMessages(data?.chatData);
            var objDiv = document.getElementById("chat-history");
            objDiv.scrollTop = objDiv.scrollHeight;

        })
        // Save socket instance in the state
        setSocket(newSocket);
    }    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const sendMessage=(type='message',fileUrl ='')=>{
        if(!messageBox && type === 'message') return;
        socket.emit("ifSendMessage",{
            "application_id":applicationId,
            "dealer_name":applicationDetails?.dealership_name,
            "bm_id":applicationDetails?.created_by,
            "role": logInUserInfo?.role,
            "message":messageBox || fileUrl,
            "user_id":logInUserInfo?.user_id,
            "source":"web",
            "name":logInUserInfo?.name,
            "type": type,
        })
        setMessageBOx("");
    }

    const inputChange=(e)=>{
        setMessageBOx(e?.target?.value)
    }

    const closeChatBox=()=>{
        document.getElementById('chat-app-outer').style.display = 'none';
        setIsConnected(false);
        if (socket) {
          socket.emit('ifLeaveRoom', { application_id: applicationId, user_id: logInUserInfo?.user_id });
          socket.disconnect();
          console.log('Disconnected from Socket.IO server');
        }
    }

    // eslint-disable-next-line no-unused-vars
    const markClosed=async ()=>{
      if(window.confirm("Are you sure ?")){
      setLoading(true);
        const response = await axios.post(`${API_URL.CHAT_URL}if-app/open-close-ticket`, {
            "application_id":applicationId,
            "action_type":"close",
            "user_id":logInUserInfo?.user_id,
            "source":"web",
            "name":logInUserInfo?.name
        },headers);
        if(response?.data?.message){
            socket.emit("ifGetChatMessages",{application_id: applicationId, page_num:1,source: "web"});
        }
        setLoading(false);
      }
    }

    const getLeadDetails = async (application_id, open_chat = true) => {
      try {
        if (open_chat) {
          const chatContainer = document.getElementById('chat-app-outer');
          if (chatContainer) {
            chatContainer.style.display = 'flex';
          }
    
          setTimeout(() => {
            const chatHistory = document.getElementById('chat-history');
            if (chatHistory) {
              chatHistory.scrollTop = chatHistory.scrollHeight;
            }
          }, 100); // allow DOM to render
        }
      } catch (error) {
        toast.error('Unable to open chat view');
      }
    };
    


  const handleUpload = useCallback(async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, application/pdf";

    input.onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("upload_type", "dif_docs");
            formData.append("lead_id", leadId);
            formData.append("images", file);

            const response = await 
            InventoryService.uploadFilesToS3(formData, {
                "Content-Type": "multipart/form-data",
            });

            if (response?.data?.status === 200) {
                const uploadedFile = response.data.data[0];
                if (uploadedFile && uploadedFile !== "not_updated") {
                    sendMessage("file",uploadedFile.file_url);
                }
            } else {
                throw new Error(response?.data?.message || "Upload failed");
            }
        } catch (error) {
            toast.error(error.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    input.click();
  }, [leadId, sendMessage]);
  

const handleFileDownload = async (url) => {
    try {
        const urlPath = url.split("?")[0];
        const fileName = urlPath.split("/").pop();

        const response = await fetch(url);
        if (!response.ok) throw new Error("Download failed");

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName || "download.file";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        toast.error("Failed to download file");
    }
};

const FileMessage = ({ content }) => {
    const urlPath = content.split("?")[0];
    const fileName = urlPath.split("/").pop();
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);

    return (
        <div className="file-message-container">
            <div className="verfication-img">
                {isImage ? (
                  <a href={content} target="_blank" rel="noopener noreferrer">
                    <img src={content} alt="Shared file" />
                  </a>
                ) : (
                  <div className="pdf-gallery">
                    <a href={content} target="_blank" rel="noopener noreferrer">
                      <i className="ic-pdf pdf-font-size"></i>
                    </a>
                  </div>
                )}
            </div>
            <div className="download-btn" onClick={() => handleFileDownload(content)}>
                <i className="ic-save_alt"></i> Download File
            </div>
        </div>
    );
};

const MessageContent = ({ message }) => {
    return message.type === "file" ? <FileMessage content={message.content} /> : <div className="chat-text">{message.content}</div>;
};

const callFilterReset = () => {
  delete filterData.refinance_status;
  setOffset(0);
}

const submitFilterForm = (filterData) => {
  setFilterData(filterData);
  setOffset(0);
  getChatList(1,{...filterData});
}

  return (
    <div className='container-fluid' >
            {loading ? <Loader /> : ''}
            <div>
                <div className='top-heading'>
                    <h2>Chat List</h2>
                </div>

                <div className="loan-filter-bg sfa-chat-top-filter">
                <div className="top-filter-bg">
                  <LeadListFilter
                    filter_data={filterData}
                    loading={loading}
                    onSubmitFilter={submitFilterForm}
                    statusOption={statusOption}
                    callFilterReset={callFilterReset}           
                  />
                </div>
              </div>

              
                    <div className="lead-list-data-table inventory-funding-list-table chat-tabel-outer" key={"bpkp"}>
                    <div className='data-table'>
                        <table key={chatdata}>
                            <thead>
                                <tr>
                                    <th >Application Id</th>
                                    <th >Dealer Name</th>
                                    <th>SFA User</th>
                                    <th>Submitted On</th>
                                    <th>Last Message On</th>
                                    <th>Last Replied By</th>
                                    <th>Latest Message</th>
                                    <th>Status</th>
                                    {/* {IS_USER_ACCESS_PAGE('OpsMessenger','ops_messenger')?.is_edit_access && */}
                                    <th>Action</th>
                                    {/* } */}
                                </tr>
                            </thead>
                            <tbody>
                                { chatdata && chatdata?.length>0 && chatdata?.map((ch)=>{
                                    return(<tr>
                                        <td>{ch.application_id}</td>
                                        <td>{ch.dealer_name}</td>
                                        <td>{ch?.created_by_name}</td>
                                        <td>{moment(ch?.created_date).format("DD MMM YYYY")}</td>
                                        <td>{ch?.last_message_date ? moment(ch?.last_message_date).format("DD MMM YYYY HH:MM A") : '-'}</td>
                                        <td>{ch?.last_reply_by}</td>
                                        <td style={{"word-break": 'break-all',
    "overflow-wrap": 'break-word'}}>{ch?.message?.includes('http') ? 'File' : ch?.message}</td>
                                        <td>{ ch?.is_read === 0 ? 'unread' : 'open' }</td>
                                        {/* {IS_USER_ACCESS_PAGE('OpsMessenger','ops_messenger')?.is_edit_access && */}
                                        <td> 
                                          <button onClick={()=>connectSocket(ch?.application_id)} title='chat'><i className="ic-remove_red_eyevisibility"></i></button>
                                        </td>
                                        
                                        {/* } */}
                                    </tr>)
                                })
                                }
                           
                            </tbody>
                        </table>
                        </div>

                <div className='pagination-bx' id="dealerList">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(pageCount / 10)}
                        marginPagesDisplayed={2}
                        forcePage = {offset}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div >
                <button 
                    onClick={() => window.location.href = "/if-application/dashboard"} 
                    className="exit-button"
                    style={{
                        padding: "8px 16px",
                        backgroundColor: "#f44336",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer"
                    }}
                >
                    Exit
                </button>
            </div>
            </div>

            <div className="chat-app-outer" id='chat-app-outer' style={{ display : 'none'}}>
        
          <div className="chatbox-main">
            <div className="chat-header">
              <div className="header-left">
              {/* <h3>{
                  `${leadDetails?.make || leadDetails?.other_make} ${leadDetails?.model || leadDetails?.other_model} ${leadDetails?.variant || leadDetails?.other_variant}` 
                }</h3> */}
              <span>{ applicationDetails?.dealership_name} ({`Application ID - ${applicationDetails?.application_id}`})</span>
              </div>
              <div className="header-right">
              {/* { ticketData && ticketData?.status===1 &&
                <button className="resolved-tag" onClick={markClosed}>
                  Mark Resolved
                </button>
              } */}
                { ticketData && ticketData?.status==='2' &&
                                <span className="resolved-tag">Resolved</span>
                }
                <i className="ic-clearclose" onClick={closeChatBox}></i>
              </div>
            </div>

            <div className="chat-history" id="chat-history">
              <ul>
                { messages && messages?.length>0 && messages?.map((msg)=>{
                  if(msg?.source!=="web"){
                    return(<li className="chat-left">
                    <MessageContent message={msg}/>
                    <span className="chat-time">{msg?.name} ({ROLE_MAPPING_SHOW_TEXT[msg?.role]}) {moment(msg?.created_date).format("DD MMM YYYY HH:MM A")}</span>
                    </li>)
                  }else{
                    return(<li className="chat-right">
                    <MessageContent message={msg}/>
                    <span className="chat-time">{msg?.name} ({msg?.role}) {moment(msg?.created_date).format("DD MMM YYYY HH:MM A")}</span>
                   
                    </li>)
                  }
                })}
                
                {/* <li className="chat-left">
                  <div className="chat-text">
                  Why this is under incomplete?
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  Dealer asking amount is higher then offering amount. So we have sent it for AM approval.
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                 
                </li>

                <li className="chat-left">
                  <div className="chat-text">
                  Okay
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  Anything else I can help you?
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>
                <li className="reopened-chat">
                  <div className="reopened-txt">It is reopened</div>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  It is taking a little time. Will update you once approved.
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li> */}
              </ul>
            </div>

            {/* <div className="defaut-msg">
              <span>Hi</span>
              <span>Ok, Thanks</span>
            </div> */}
            { ticketData &&( ticketData?.status === '1'||  ticketData?.status === '2') &&
            <div className="chat-msg-box">
              <input type="text" className="form-input" value={messageBox} onChange={(e)=>inputChange(e)} placeholder="Say Something" />

              <div className="chat-send-btn m-xs-r" onClick={handleUpload}>
                <i className="ic-attach_file"></i>
              </div>
              <div className="chat-send-btn" onClick={()=>sendMessage()}>
                <i className="ic-keyboard_arrow_right"></i>
              </div>
            </div>
          }
          
        </div>
      </div>
        </div>
  )
}

const mapStateToProps = (state) => {
  return {
      auth_token: state.authToken,
      user_loggedin: state.userLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      updateStateIntoRedux: (actionType, stateData) => dispatch({ type: actionType, componentState: stateData }),
  };
};
export default withTranslation("if_application")(connect(mapStateToProps, mapDispatchToProps)(SfaChat));